"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAlternativeLabelsProperty = exports.alternativeLabelsPropertyDefinition = void 0;
exports.alternativeLabelsPropertyDefinition = {
    view: { label: 'Alternative labels' },
    constraints: [],
    type: 'text',
    multiple: true,
    name: 'alternative-labels',
};
const isAlternativeLabelsProperty = (prop) => {
    return prop.name === exports.alternativeLabelsPropertyDefinition.name;
};
exports.isAlternativeLabelsProperty = isAlternativeLabelsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWx0ZXJuYXRpdmUtbGFiZWxzLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvYWx0ZXJuYXRpdmUtbGFiZWxzLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsbUNBQW1DLEdBQUc7SUFDakQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLG9CQUFvQixFQUFFO0lBQ3JDLFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxvQkFBb0I7Q0FDSyxDQUFBO0FBSTFCLE1BQU0sMkJBQTJCLEdBQUcsQ0FBQyxJQUFrQixFQUFxQyxFQUFFO0lBQ25HLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywyQ0FBbUMsQ0FBQyxJQUFJLENBQUE7QUFDL0QsQ0FBQyxDQUFBO0FBRlksUUFBQSwyQkFBMkIsK0JBRXZDIn0=